import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { AgmMap } from '@agm/core';
import { Experience } from 'src/app/shared/models/experience.model';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { ExperiencesService } from 'src/app/experiences/experiences.service';
import { SharedService } from 'src/app/shared/shared.service';
declare var $;
@Component({
  selector: 'app-view-experience',
  templateUrl: './view-experience.component.html',
  styleUrls: ['./view-experience.component.css']
})
export class ViewExperienceComponent
  implements OnInit, OnChanges, AfterViewInit {
  @Input() experienceRow;
  @ViewChild('map', { static: false }) map: AgmMap;
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeAddExpenseModal', { static: false })
  closeAddExpenseModal: ElementRef;
  countryRelatedCities = [];
  countriesWithCities = [];
  country: string;
  city: string;
  locationChange = false;
  private maplatitude = 29.0104002;
  private maplongitude = 31.7408658;
  mapType = 'roadmap';
  zoom = 7;
  markerDraggable = false;
  animation = 'DROP';
  experience: Experience;
  weekdays = [];
  startDay: string;
  rowExp: any;
  constructor(private experienceApi: ExperiencesService, private sharedApi: SharedService, private router: Router) {}

  ngOnInit() {
    moment.weekdays().forEach((element, index) => {
      const ind = Number(index) + 1;
      this.weekdays.push({ id: ind, name: element });
    });
    this.sharedApi.getAllCountries().subscribe((res: any) => {
      // console.log(res)
      this.countriesWithCities = res.data.countries;
    });
    // if(this.map)
    // $(this.modal.nativeElement).on('shown.bs.modal', () => this.map.triggerResize());
  }
  ngAfterViewInit() {
    if (this.map) {
      $(this.modal.nativeElement).on('shown.bs.modal', () =>
        this.map.triggerResize()
      );
    }
  }
  ngOnChanges() {
    // console.log(this.experienceRow)
    this.experience = {};

    this.experienceApi
      .getSingleExperienceById(this.experienceRow.id)
      .subscribe(Response => {
        // console.log(Response);

        this.experience = Response.data.experience;
        const findValue = this.weekdays.find(
          x => x.id === this.experience.startIndex
        );
        // this.startDay = findValue.name;
        this.sharedApi.getAllCountries().subscribe((res: any) => {
          // console.log(res)
          this.countriesWithCities = res.data.countries;
        });
        // if (this.countriesWithCities) {
          if (Response.data.experience.City[`countryId`]) {
            const country = this.getCountryCities(
              Response.data.experience.City[`countryId`]
            );
            if (country) {
              this.country = country[`name`];
            }
          }
        // }
        // console.log(country)
        
        this.city = Response.data.experience.City.name;
      });
  }

  getCountryCities(countryId): string {
    let cities;
    this.sharedApi.getAllCities(countryId).subscribe((Response) => {
        cities = Response.data.cities;
      });
    return cities;
  }
  viewExpSchedule() {
    this.closeAddExpenseModal.nativeElement.click();
    this.router.navigateByUrl('/experiences/schedule/' + this.experience.id);
  }
  cancel() {}
}
